// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"12215e9f","186":"ebea00e6","225":"4011471f","272":"447c242b","372":"01d3e289","573":"451d1ad5","738":"7d7849cc","841":"5a6bf460","856":"716014c5","909":"fdc97555"}[chunkId] + ".chunk.js";
};